import * as React from "react";
import type { SVGProps } from "react";
const SvgThumbsUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.11 21H10a4 4 0 0 1-2.4-.8A2 2 0 0 1 6 21H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3a3 3 0 0 0 3-3V6a3 3 0 0 1 6 0v4h2a3 3 0 0 1 3 3q.008.1 0 .2l-1 5c-.42 1.69-1.58 2.8-2.89 2.8M8 17a2 2 0 0 0 2 2h7c.42 0 .84-.43 1-1.23l1-4.85a1 1 0 0 0-1-.92h-3a1 1 0 0 1-1-1V6a1 1 0 0 0-2 0v1a5 5 0 0 1-4 4.9zm-4-5v7h2v-7z"
    />
  </svg>
);
export default SvgThumbsUp;
